import { createApi } from '@reduxjs/toolkit/query/react';
import { commonBaseQuery } from './common';

export const servicesApi = createApi({
  reducerPath: 'servicesApi',
  baseQuery: commonBaseQuery({ prefix: 'v1' }),
  tagTypes: [
    'Organisme',
    'Organismes',
    'OrganismeUtilisateurs',
    'OrganismeFichiers',
    'Campagne',
    'CampagneFichiers',
    'CampagneRncps',
    'Etablissement',
    'Etablissements',
    'EtablissementFichiers',
    'EtablissementsRncps',
    'Rncps',
    'SessionContext',
    'MotifsMail',
    'ArchivesKaroussel',
  ],
  endpoints: (build) => ({
    getBackendVersion: build.query<{ version: string }, void, any>({
      query: () => '../api/version',
    }),
  }),
});

export const { useGetBackendVersionQuery } = servicesApi;
